import { render, staticRenderFns } from "./tableMain.vue?vue&type=template&id=97a10f26"
import script from "./tableMain.vue?vue&type=script&lang=js"
export * from "./tableMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports